var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "width": "400",
      "title": "编辑客户信息"
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "公司名",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入名字..."
    },
    model: {
      value: _vm.formItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "name", $$v);
      },
      expression: "formItem.name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "简称",
      "prop": "abbr"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入简称..."
    },
    model: {
      value: _vm.formItem.abbr,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "abbr", $$v);
      },
      expression: "formItem.abbr"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "法人代表",
      "prop": "legalRep"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入法人代表..."
    },
    model: {
      value: _vm.formItem.legalRep,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "legalRep", $$v);
      },
      expression: "formItem.legalRep"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "网址",
      "prop": "web"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入网址..."
    },
    model: {
      value: _vm.formItem.web,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "web", $$v);
      },
      expression: "formItem.web"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入邮箱..."
    },
    model: {
      value: _vm.formItem.email,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "email", $$v);
      },
      expression: "formItem.email"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "信用代码",
      "prop": "creditCode"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入信用代码..."
    },
    model: {
      value: _vm.formItem.creditCode,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "creditCode", $$v);
      },
      expression: "formItem.creditCode"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "参保人数",
      "prop": "socialSecurityCount"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入参保人数..."
    },
    model: {
      value: _vm.formItem.socialSecurityCount,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "socialSecurityCount", $$v);
      },
      expression: "formItem.socialSecurityCount"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "注册资本",
      "prop": "regisCapi"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入注册资本..."
    },
    model: {
      value: _vm.formItem.regisCapi,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "regisCapi", $$v);
      },
      expression: "formItem.regisCapi"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "实缴资本",
      "prop": "paidCapi"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入实缴资本..."
    },
    model: {
      value: _vm.formItem.paidCapi,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "paidCapi", $$v);
      },
      expression: "formItem.paidCapi"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "所属行业",
      "prop": "industry"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入所属行业..."
    },
    model: {
      value: _vm.formItem.industry,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "industry", $$v);
      },
      expression: "formItem.industry"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "所属省份",
      "prop": "province"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入所属省份..."
    },
    model: {
      value: _vm.formItem.province,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "province", $$v);
      },
      expression: "formItem.province"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "所属城市",
      "prop": "city"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入所属城市..."
    },
    model: {
      value: _vm.formItem.city,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "city", $$v);
      },
      expression: "formItem.city"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "所属区县",
      "prop": "dist"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入所属区县..."
    },
    model: {
      value: _vm.formItem.dist,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "dist", $$v);
      },
      expression: "formItem.dist"
    }
  })], 1), _c('FormItem', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }